function loadExternalScript(id, src) {
  if (id === "chart-js" && window.Chart) return Promise.resolve();

  const existing = document.getElementById(id);
  if (existing) {
    if (existing.dataset.loaded === "true") return Promise.resolve();
    return new Promise((resolve, reject) => {
      existing.addEventListener("load", resolve, { once: true });
      existing.addEventListener("error", reject, { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = id;
    script.src = src;
    script.async = true;
    script.addEventListener("load", () => {
      script.dataset.loaded = "true";
      resolve();
    }, { once: true });
    script.addEventListener("error", error => {
      script.remove();
      reject(error);
    }, { once: true });
    document.head.appendChild(script);
  });
}

function reportPageModuleError(name, error) {
  console.error(`No se pudo cargar el módulo ${name}:`, error);
}

function initializePageModules() {
  const action = document.body.dataset.controller;
  const controller = document.body.dataset.controllerName;

  if (action === "home" || action === "monitoring") {
    import(/* webpackChunkName: "home" */ "./packs/initialize_home")
      .then(module => module.initializeHomeFeatures())
      .catch(error => reportPageModuleError("home", error));
  }

  if (action === "monitoring") {
    import(/* webpackChunkName: "monitoring-page" */ "./packs/monitoring")
      .then(module => module.initializeMonitoringPage())
      .catch(error => reportPageModuleError("monitoring", error));
  }

  if (action === "prevision") {
    import(/* webpackChunkName: "prevision" */ "./packs/prevision_page")
      .then(module => module.initializePrevisionPage())
      .catch(error => reportPageModuleError("prevision", error));
  }

  if (["minimas", "maximas", "precipitaciones", "vientos", "emas"].includes(action)) {
    import(/* webpackChunkName: "extremes" */ "./packs/extremes_page")
      .then(module => {
        module.initializeExtremesPage();
        if (action === "emas" && window.MeteoEmasPage) {
          window.MeteoEmasPage.initialize();
        }
      })
      .catch(error => reportPageModuleError("extremos", error));
  }

  if (controller === "retspies" && document.getElementById("mapReTSPy")) {
    loadExternalScript("chart-js", "https://cdn.jsdelivr.net/npm/chart.js")
      .then(() => import(/* webpackChunkName: "retspy-page" */ "./packs/retspy"))
      .then(module => module.initializeRetspyPage())
      .catch(error => reportPageModuleError("RETSPY", error));
  }

  if (document.querySelector("textarea.tinymce")) {
    import(/* webpackChunkName: "tinymce-editor" */ "./packs/tinymce_extras")
      .then(() => import(/* webpackChunkName: "tinymce-editor" */ "./packs/tinymce_init"))
      .then(module => module.initializeTinyMcePage())
      .catch(error => reportPageModuleError("TinyMCE", error));
  }
}

document.addEventListener("turbolinks:load", initializePageModules);
document.addEventListener("turbolinks:before-cache", () => {
  if (document.body.dataset.controller === "emas" && window.MeteoEmasPage) {
    window.MeteoEmasPage.cleanup();
  }
});
